module.exports = __webpack_public_path__ + "static/img/produto_g.421fdb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/spremidos-citrus/produto_g.png
// module id = zsAl
// module chunks = 0